import * as _m from '@/models';
import { Link, useLocation } from 'react-router-dom';
import { NumberCompactFormat } from '@/components/common/NumberCompactFormat';
import ReactTimeAgo from 'react-time-ago';

type Props = {
  channel_post: _m.ChannelPost;
};

export const ChannelPostTileElement = ({ channel_post }: Props) => {
  const location = useLocation();

  return (
    <Link
      to={`/channels/${channel_post.channel_outline.cid}/channel_posts/${channel_post.id}`}
      // state={{ backgroundLocation: location }}
    >
      <div className="cover-wrapper">
        <img src={channel_post.cover_image_url} className="cover" />
        <span className="time">{channel_post.channel_post_movie.duration_label}</span>
      </div>
      <div className={'content'}>
        <h5>{channel_post.title}</h5>
        <ul className={'meta'}>
          <li>
            <NumberCompactFormat val={channel_post.movie_plays_count} />
            回視聴
          </li>
          <li>
            <ReactTimeAgo date={new Date(channel_post.posted_at)} locale="ja" />
          </li>
        </ul>
      </div>
    </Link>
  );
};
